var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    transform: "rotate(-180 31 31)",
    fill: "#5EB5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 40C30 40.5523 30.4477 41 31 41C31.5523 41 32 40.5523 32 40L31 40L30 40ZM31.7071 21.2929C31.3166 20.9024 30.6834 20.9024 30.2929 21.2929L23.9289 27.6569C23.5384 28.0474 23.5384 28.6805 23.9289 29.0711C24.3195 29.4616 24.9526 29.4616 25.3431 29.0711L31 23.4142L36.6569 29.0711C37.0474 29.4616 37.6805 29.4616 38.0711 29.0711C38.4616 28.6805 38.4616 28.0474 38.0711 27.6569L31.7071 21.2929ZM31 40L32 40L32 22L31 22L30 22L30 40L31 40Z",
    fill: "#F5F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.c9f0603094c6b9e6ce620342fca71fc6.svg";
export { ForwardRef as ReactComponent };